//import { useState } from "react";
import useCopyToClipboard from "../hooks/useCopyToClipboard";

export default function SubjectLineList({ subjects }) {
  // const [copiedIndex, setCopiedIndex] = useState(null);

  // const copyToClipboard = (text, index) => {
  //   navigator.clipboard.writeText(text);
  //   setCopiedIndex(index);
  //   // Reset the "Copied!" message after 2 seconds
  //   setTimeout(() => setCopiedIndex(null), 2000);
  // };

  const [, copiedIndex, copy] = useCopyToClipboard();

  if (!subjects || subjects.length === 0) return null;

  return (
    <div className="max-w-3xl mt-8 animate-fadeIn">
      <h3 className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-4 px-2">
        Suggested Subject Lines
      </h3>

      <div className="grid gap-3">
        {subjects.map((line, index) => {
          const isSafe = line.length <= 45;

          return (
            <div
              key={index}
              onClick={() => copy(line, index)}
              className="group relative bg-white p-5 rounded-xl border border-slate-200 hover:border-indigo-400 hover:shadow-md cursor-pointer transition-all flex items-center justify-between"
            >
              <span className="text-slate-700 font-medium pr-10">{line}</span>

              <span
                className={`text-[10px] font-black px-2 py-0.5 rounded-md uppercase tracking-tighter ${
                  isSafe
                    ? "bg-green-100 text-green-700"
                    : "bg-amber-100 text-amber-700"
                }`}
              >
                {line.length} Chars •{" "}
                {isSafe ? "Mobile Optimized" : "Potential Cutoff"}
              </span>

              <div className="flex items-center gap-2">
                {copiedIndex === index ? (
                  <span className="text-xs font-bold text-green-500 bg-green-50 px-2 py-1 rounded">
                    Copied!
                  </span>
                ) : (
                  <svg
                    className="w-5 h-5 text-slate-300 group-hover:text-indigo-500 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                    />
                  </svg>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
